import { render, staticRenderFns } from "./PriceCell.vue?vue&type=template&id=5ce7f0de"
import script from "./PriceCell.vue?vue&type=script&lang=js"
export * from "./PriceCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports